import React, { useState, useEffect } from 'react'
import Header from '../components/Header/Header'
import { Form } from 'react-final-form'
import { useSearchCarPurchaseTypesMutation } from '../../../services'
import { UspConfigurationCarPurchaseTypeView } from '../../../models'
import InventoryPurchaseTypesTable from './components/InventoryPurchaseTypesTable'
import AddEditPurchaseTypeModal from './components/AddEditPurchaseTypeModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsInventoryPurchaseTypes = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchCarPurchaseTypes, { data, isLoading }] = useSearchCarPurchaseTypesMutation()
  const [carPurchaseTypesData, setCarPurchaseTypesData] = useState<UspConfigurationCarPurchaseTypeView[]>([])

  const handleSubmit = (values?: any) => {
    searchCarPurchaseTypes({
      uspConfigurationCarPurchaseTypeView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setCarPurchaseTypesData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Purchase Types'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <InventoryPurchaseTypesTable
                      data={carPurchaseTypesData}
                      loading={isLoading}
                      setData={setCarPurchaseTypesData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditPurchaseTypeModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationCarPurchaseTypeView}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsInventoryPurchaseTypes
